import { quillEditor } from 'vue-quill-editor';
import quillConfig from './quill-config.js';
export default {
  props: ['content', 'index'],
  components: {
    quillEditor
  },
  data() {
    return {
      // content: '<h2>hello quill-editor</h2>',
      quillOption: quillConfig
    };
  },
  methods: {
    onEditorChange() {
      this.$emit('input', this.content, this.index);
    }
  }
};